import HTTPDataPlateforme from '@/api/HTTPDataPlateforme';

export default async function getMarques(payload) {
  const queryItems = {
    nom: payload.nom,
  };
  const response = await HTTPDataPlateforme.put('getMarques', queryItems);
  return response;
}
